/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorTable.vue?vue&type=template&id=589ba4b5&scoped=true"
import script from "./DoctorTable.vue?vue&type=script&lang=js"
export * from "./DoctorTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorTable.vue?vue&type=style&index=0&id=589ba4b5&scoped=true&lang=css"
import style1 from "./DoctorTable.vue?vue&type=style&index=1&id=589ba4b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ba4b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589ba4b5')) {
      api.createRecord('589ba4b5', component.options)
    } else {
      api.reload('589ba4b5', component.options)
    }
    module.hot.accept("./DoctorTable.vue?vue&type=template&id=589ba4b5&scoped=true", function () {
      api.rerender('589ba4b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DoctorTable.vue"
export default component.exports